import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import TagReportTabResultListViewModel from "./tag-report-tab-result-list-view-model";
import TagReportTabResultDiagramViewModel from "./tag-report-tab-result-diagram-view-model";
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-date-time-box";
function TagReportViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.TagType = {
        numeric: "1eb0ef5b-07bd-476c-8415-d32931cd6bca",
        alphanumeric: "c694105e-3356-4fd9-a702-682e2e18520c"
    };
    
    self.Initialized = ko.observable(false);
    self.ReportLoaded = ko.observable(false);
    self.UniversalFieldName = ko.observable();
    self.TagName = ko.observable();
    self.TagId = ko.observableArray([]);
    self.SelectedTag = ko.observable([]);
    var stringToday = new Date().toISOString().replace(/\..{4}$/, "").replace(/-/g, "").replace(/:/g, "").replace("T", "").substr(0, 8) + "000000";
    self.StartDateTime = ko.observable(stringToday);
    self.EndDateTime = ko.observable(stringToday);
    self.TagTextValue = ko.observable("");
    self.TabViewModel = new TabController(false);
    self.Models = ko.observableArray([]);
    self.AllModels = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observable([]);
    self.ResultTabList = null;
    self.ResultTabDiagram = null;
    self.SelectedShiftbook = ko.observable();

    
    self.ShiftbookName = ko.observable();
    self.ShiftbookId = ko.observable();


    self.DiagramDataSet = ko.pureComputed(function () {
        var entries = self.AllModels();
        var data = {
            x: "x",
            columns: [["data1"], ["x"]],
            types: {
                data1: "line"
            },
            names: {
                data1: self.TagName()
            }
        };
        if (entries.length > 0 && self.TagIsNumeric()) {
            for (var i in entries) {
                var y = ko.unwrap(entries[i].NumericValue);
                if (typeof y === "undefined" || y === null) {
                    y = 0;
                }
                data.columns[0].push(y);
                var label = ko.unwrap(entries[i].InsertDateHtml);
                if (typeof label === "undefined" || label === null) {
                    label = "";
                }
                label = label.substr(0, 10) + label.substr(10, 6);
                data.columns[1].push(label);
            }
        }
        return data;
    });
    self.DiagramTicks = ko.pureComputed(function () {
        var entries = self.AllModels();
        var result = [];
        if (entries.length > 0 && self.TagIsNumeric()) {
            for (var i in entries) {
                var x = Number(i) + 0;
                var label = ko.unwrap(entries[i].InsertDateHtml);
                if (typeof label === "undefined" || label === null) {
                    label = "";
                }
                label = label.substr(0, 10) + label.substr(10, 6);
                result.push([x, label]);
            }
        }
        return result;
    });
    self.TagIsNumeric = ko.pureComputed(function () {
        let isNumeric: boolean = false;

        if (Boolean(typeof ko.unwrap(self.SelectedTag) !== "undefined" && ko.unwrap(self.SelectedTag) !== null)) {
            if (ko.unwrap(self.SelectedTag).length == 1 && ko.unwrap(ko.unwrap(self.SelectedTag)[0].UniversalFieldTypeId) === self.TagType.numeric) {
                isNumeric = true;
            }
        }

        return isNumeric;
    });
    self.TagIsAlphanummeric = ko.pureComputed(function () {
        let IsAlphanummeric: boolean = false;

        if (Boolean(typeof ko.unwrap(self.SelectedTag) !== "undefined" && ko.unwrap(self.SelectedTag) !== null)) {
            if (ko.unwrap(self.SelectedTag).length ==1 && ko.unwrap(ko.unwrap(self.SelectedTag)[0].UniversalFieldTypeId) === self.TagType.alphanumeric) {
                IsAlphanummeric = true;
            }
        }

        return IsAlphanummeric;
    });
    self.IsReportResultEmpty = ko.pureComputed(function () {
        return Boolean(self.ReportLoaded() && typeof self.Models() !== "undefined" && self.Models().length === 0);
    });
    self.PageIndex.subscribe(function () {
        if (self.Initialized() && self.ReportLoaded()) {
            parent.TabPage.IsLoading(true);
            self.RefreshModels().done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            });
        }
    });
    self.Sorting.subscribe(function () {
        if (self.Initialized() && self.ReportLoaded()) {
            parent.TabPage.IsLoading(true);
            $.when(self.RefreshModels(), self.RefreshDiagramModels()).done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            });
        }
    });
    self.Download = function () {
        if (!self.IsComplete()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SelectOneTag"), "info");
            return;
        }
        if (!self.IsValidDateFields()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        var filterobjects = ["TagId", "StartDateTime", "EndDateTime"];
        if (self.TagIsAlphanummeric()) {
            filterobjects.push("TagTextValue");
        }

        if (self.ShiftbookId()) {
            filterobjects.push("ShiftbookId");
        }

        var data = {
            filter: self.parent.GetFilterHashObject(filterobjects, self),
            sorting: []
        };
        self.parent.DownloadReport("TagReport", data);
    };
    self.IsComplete = function () {
        return Boolean(ko.isObservable(self.TagId) && self.TagId() && self.TagId().length > 0 && !Bao.Utils.String.IsNullOrEmpty(self.StartDateTime()) && !Bao.Utils.String.IsNullOrEmpty(self.EndDateTime()));
    };
    self.IsValidDateFields = function () {
        return Boolean(Bao.Utils.String.IsNullOrEmpty(self.StartDateTime()) || Bao.Utils.String.IsNullOrEmpty(self.EndDateTime()) || Number(self.EndDateTime()) >= Number(self.StartDateTime()));
    };
    self.GetTagReportResult = function (sorting, pageIndex, pageSize, saveFilter) {
        var filterobjects = ["TagId", "StartDateTime", "EndDateTime", "TagName"];
        if (self.TagIsAlphanummeric()) {
            filterobjects.push("TagTextValue");
        }

        if (self.ShiftbookId()) {
            filterobjects.push("ShiftbookId");
        }

        var filter = self.parent.GetFilterHashObject(filterobjects, self);
        if (saveFilter === true) {
            self.parent.SaveFilter(filter, sorting, 0);
        }
        return Bao.post("ReportCenter/TagGetReportResult", JSON.stringify({
            filter: filter,
            sorting: sorting,
            pageIndex: pageIndex,
            pageSize: pageSize
        }));
    };
    self.RefreshModels = function () {
        return self.GetTagReportResult(self.Sorting(), self.PageIndex(), self.PageSize(), true).done(function (result) {
            if (result.Result == true) {
                self.Models(result.Models);
                self.TotalRows(result.TotalRows);
            }
        });
    };
    self.RefreshDiagramModels = function () {
        return self.GetTagReportResult(self.Sorting(), 0, 0).done(function (result) {
            if (result.Result == true) {
                self.AllModels(result.Models);
            }
        });
    };
    self.Display = function () {
        if (!self.IsComplete()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SelectOneTag"), "info");
            return;
        }
        if (!self.IsValidDateFields()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        parent.TabPage.IsLoading(true);
        self.TabViewModel.SelectTab(self.ResultTabList);
        self.RefreshModels().done(function () {
            if (self.TagIsNumeric()) {
                self.RefreshDiagramModels().done(function () {
                    self.ReportLoaded(true);
                    parent.TabPage.IsLoading(false);
                }).fail(function () {
                    self.ReportLoaded(false);
                    parent.TabPage.IsLoading(false);
                });
            }
            else {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            }
            if (self.ResultTabDiagram !== null) {
                self.ResultTabDiagram.Visible(self.TagIsNumeric());
            }
        }).fail(function () {
            self.ReportLoaded(false);
            parent.TabPage.IsLoading(false);
        });
    };
    self.getTagReportModel = function () {
        return Bao.post("ReportCenter/TagGetReportModel", JSON.stringify({}));
    };
    self.init = function () {
        var def = $.Deferred();
        self.getTagReportModel().done(function (result) {
            ko.map.fromJS(result, self);
            self.Initialized(true);
            def.resolve();
        });
        return def.promise();
    };
    self.loaded = function () {
        self.ResultTabList = new TabPage(null);
        self.ResultTabList.Url("ReportCenter/TagReportTabResultList");
        self.ResultTabList.AutoSelect = true;
        self.ResultTabList.IsClosable(false);
        self.ResultTabList.PreLoad(true);
        self.ResultTabList.Visible(true);
        self.ResultTabList.ViewModel(new TagReportTabResultListViewModel(self.TabPage, self));
        self.ResultTabList.Bao = Bao;
        self.TabViewModel.AddTab(self.ResultTabList);
        self.ResultTabDiagram = new TabPage(null);
        self.ResultTabDiagram.Url("ReportCenter/TagReportTabResultDiagram");
        self.ResultTabDiagram.AutoSelect = false;
        self.ResultTabDiagram.IsClosable(false);
        self.ResultTabDiagram.PreLoad(true);

        self.ResultTabDiagram.Visible(self.TagIsNumeric());

        self.ResultTabDiagram.ViewModel(new TagReportTabResultDiagramViewModel(self.TabPage, self.DiagramDataSet, self.DiagramTicks));
        self.ResultTabDiagram.Bao = Bao;
        self.TabViewModel.AddTab(self.ResultTabDiagram);
    };
}
export default TagReportViewModel;